// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresResultsGetBody = {
  poolId: string;
  ownerKind?: "member" | "guest" | null;
  ownerId?: string | null;
  eventId?: string | null;
  labelKey?:
    | "q1"
    | "half"
    | "q3"
    | "p1"
    | "p2"
    | "after3"
    | "after5"
    | "after7"
    | "final"
    | "custom"
    | null;
};

export type typeSquaresResultsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    standings: {
      rank: number;
      ownerKind: "member" | "guest";
      ownerId: string;
      displayName: string;
      initials: string;
      isGuest: boolean;
      winCount: number;
      squareCount: number;
      breakdown: {
        labelKey:
          | "q1"
          | "half"
          | "q3"
          | "p1"
          | "p2"
          | "after3"
          | "after5"
          | "after7"
          | "final"
          | "custom";
        label: string;
        count: number;
      }[];
    }[];
    gameGroups: {
      eventId: string;
      gridId: string;
      homeTeamId: string;
      awayTeamId: string;
      kickoffAt: string;
      roundLabel?: string | null;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      homeScore?: number | null;
      awayScore?: number | null;
      periodLabel?: string | null;
      clockLabel?: string | null;
      winners: {
        winnerId: string;
        gridId: string;
        eventId: string;
        labelKey:
          | "q1"
          | "half"
          | "q3"
          | "p1"
          | "p2"
          | "after3"
          | "after5"
          | "after7"
          | "final"
          | "custom";
        label: string;
        source: "auto" | "admin";
        sourceNote: "setAutomatically" | "setByAdmin" | "addedByAdmin";
        squareKey?: string | null;
        topDigit: number;
        sideDigit: number;
        ownerKind?: "member" | "guest" | null;
        ownerId?: string | null;
        displayName?: string | null;
        initials?: string | null;
        isGuest: boolean;
        homeScore: number;
        awayScore: number;
      }[];
      pendingRows: {
        checkpointKey:
          | "q1"
          | "half"
          | "q3"
          | "p1"
          | "p2"
          | "after3"
          | "after5"
          | "after7"
          | "final";
        label: string;
        state: "upcoming" | "waitingForFinal" | "adminSets";
      }[];
      canAddWinner: boolean;
      customTitle?: string | null;
      customTopLabel?: string | null;
      customSideLabel?: string | null;
    }[];
    filterChips: {
      labelKey:
        | "q1"
        | "half"
        | "q3"
        | "p1"
        | "p2"
        | "after3"
        | "after5"
        | "after7"
        | "final"
        | "custom";
      label: string;
    }[];
    isChipRowShown: boolean;
    userOptions: {
      ownerKind: "member" | "guest";
      ownerId: string;
      displayName: string;
      isGuest: boolean;
    }[];
    gameOptions: { eventId: string; label: string }[];
  };
};

export type typeSquaresResultsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresResultsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresResultsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresResultsGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    ownerKind: {
      oneOf: [{ type: "string", enum: ["member", "guest"] }, { enum: [null] }],
    },
    ownerId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    eventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    labelKey: {
      oneOf: [
        {
          type: "string",
          enum: [
            "q1",
            "half",
            "q3",
            "p1",
            "p2",
            "after3",
            "after5",
            "after7",
            "final",
            "custom",
          ],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresResultsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresResultsGetBody);
  }

  return async function postSquaresResultsGet(
    payload: typeSquaresResultsGetBody,
  ): Promise<typeSquaresResultsGetOutput200 | typeSquaresResultsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresResultsGet" failed before calling the network. #e5106f7a1210`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e5106f7a1210" },
        },
        data: null,
      } as typeSquaresResultsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/results-get`,
      httpMethod: "POST",
      options,
    })) as typeSquaresResultsGetOutput200 | typeSquaresResultsGetOutput400;
  };
}
